module.exports = {
  fichasNameData: () => {
    return{
      "IONIQ 5 EV-POWER": "FT-IONIQ-5-EV-POWER.pdf",
      "TUCSON HEV LIMITED": "FT-TUCSON-HIBRIDA.pdf",
      "PALISADE SPORT": "FT-PALISADE-SPORT.pdf",
      "STARIA LUJO": "FT-STARIA-LUJO.pdf",
      "VENUE LIMITED AT": "FT-VENUE.pdf",
      "HB20 ADVANCE": "FT-HB20-HATCHBACK.pdf",
      "HB20S ADVANCE": "FT-HB20S-SEDAN.pdf",
      "CRETA PREMIUM": "FT-NUEVA-CRETA.pdf",
      "KONA HEV LIMITED": "FT-NUEVA-KONA-HIBRIDA-HEV.pdf",
      "SANTA FE HEV LIMITED 4x4": "FT-SANTAFE-HEV.pdf",

      "GRAND i10 AT PREMIUM": "FT-GRAND-I10-PARTICULAR.pdf",
      "PALISADE HEV 4x4": "FT-PALISADE-HIBRIDA.pdf",
    }
  }
}